var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12 0c.013 0 .023.006.036.007a11.963 11.963 0 0 1 8.45 3.507 11.96 11.96 0 0 1 3.506 8.45c.001.012.008.023.008.036 0 .012-.007.023-.008.036a11.96 11.96 0 0 1-3.507 8.45.997.997 0 0 1-1.414 0l-1.414-1.415a.999.999 0 1 1 1.414-1.414l.671.671A9.952 9.952 0 0 0 21.944 13H21a1 1 0 1 1 0-2h.944a9.952 9.952 0 0 0-2.202-5.329l-.67.672a.997.997 0 0 1-1.415 0 .999.999 0 0 1 0-1.414l.671-.672A9.955 9.955 0 0 0 13 2.057V3a1 1 0 1 1-2 0v-.944a9.963 9.963 0 0 0-5.328 2.201l.671.672A1 1 0 0 1 4.93 6.343l-.67-.672a9.953 9.953 0 0 0-2.204 5.33H3a1 1 0 1 1 0 2h-.945a9.953 9.953 0 0 0 2.203 5.327l.671-.67a.999.999 0 1 1 1.414 1.413L4.93 20.485a1.001 1.001 0 0 1-1.415 0 11.954 11.954 0 0 1-3.506-8.449C.008 12.023 0 12.012 0 12c0-.013.007-.024.008-.037a11.954 11.954 0 0 1 3.506-8.449 11.965 11.965 0 0 1 8.45-3.507C11.976.007 11.987 0 12 0zm2.828 7.757a.999.999 0 1 1 1.414 1.414l-2.75 2.751c.001.026.008.051.008.078a1.5 1.5 0 1 1-1.5-1.5c.026 0 .052.006.078.007z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    transform: "translate(0 2)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePerformance);
export default __webpack_public_path__ + "static/media/blue-performance.6b2f12499864550d7740b945c895c55f.svg";
export { ForwardRef as ReactComponent };